import { isNilOrEmpty } from '@pcty/utils';
/**
 * Filters and formats a string into US currency
 * @param {string | number} value - The original string
 */
export var currencyUSDFormatter = function (value) {
    value = value === null || value === void 0 ? void 0 : value.toString().replace(/[^\d.-]+/g, '');
    if (isNilOrEmpty(value) || isNaN(parseFloat(value)))
        return '';
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(value);
};
